export enum SelectedState {
	selectedInRange,
	selectedInside,
}
